import { isCrediMart } from "./helper";

export function getCategoryIcon(url: string) {
  return url.replace("/img/", "/img/credimart/");
  //return url;
}
